/* eslint-disable no-shadow */
import { Suspense, lazy } from "react";
import t from "prop-types";
import { Route, Switch } from "react-router-dom";
import { ROLES } from "@app/constants";
import FullScreenLoading from "@app/common/components/FullScreenLoad";

// const TherapistDashboardContainer = lazy(() => import("./therapist/components/dashboard"));
const ClinicAdministratorDashboardContainer = lazy(() => import("./clinic_administrator/components/Dashboard"));
const ClinicalSupervisorDashboardContainer = lazy(() => import("./clinical_supervisor/components/Dashboard"));
const StudentDashboardContainer = lazy(() => import("./student/containers/dashboard"));
const SpedDashboard = lazy(() => import("./sped/containers/dashboard"));
const SysAdminDashboard = lazy(() => import("./system_admin/containers/dashboard"));
const TherapistDashboard = lazy(() => import("./therapist/containers/dashboard"));
const HomeRoutes = props => {
  if (!props.show) {
    return <div />;
  }

  return (
    <Switch>
      {[ROLES.THERAPIST.id, ROLES.TRAINER.id].includes(props.userRole) && (
        <Route
          exact
          path="/home/:tab?"
          render={props => (
            <Suspense fallback={<FullScreenLoading />}>
              <TherapistDashboard tab={props.match.params.tab} {...props} />
            </Suspense>
          )}
        />
      )}
      {props.userRole === ROLES.CLINICAL_SUPERVISOR.id && (
        <Route
          exact
          path={`${props.match.path}/`}
          render={props => (
            <Suspense fallback={<FullScreenLoading />}>
              <ClinicalSupervisorDashboardContainer {...props} />
            </Suspense>
          )}
        />
      )}
      {props.userRole === ROLES.CLINIC_ADMINISTRATOR.id && (
        <Route
          exact
          path="/home/:tab?/:schoolId?"
          render={props => (
            <Suspense fallback={<FullScreenLoading />}>
              <ClinicAdministratorDashboardContainer tab={props.match.params.tab} {...props} />
            </Suspense>
          )}
        />
      )}

      { [ROLES.SYSTEM_ADMIN.id, ROLES.TECH_SUPPORT.id].includes(props.userRole) && (
        <Route
          path="/home/:tab?/:param1?/:param2?/:param3?/:param4?"
          render={props => (
            <Suspense fallback={<FullScreenLoading />}>
              <SysAdminDashboard tab={props.match.params.tab} {...props} />
            </Suspense>
          )}
        />
      )}

      {props.userRole === ROLES.STUDENT.id && (
        <Route
          exact
          path={`${props.match.path}/:tab?`}
          render={props => (
            <Suspense fallback={<FullScreenLoading />}>
              <StudentDashboardContainer tab={props.match.params.tab} {...props} />
            </Suspense>
          )}
        />
      )}

      {props.userRole === ROLES.SPED.id && (
        <Route
          exact
          path="/home/:tab?/:param1?/:param2?/:param3?/:param4?"
          render={props => (
            <Suspense fallback={<FullScreenLoading />}>
              <SpedDashboard tab={props.match.params.tab} {...props} />
            </Suspense>
          )}
        />
      )}
    </Switch>
  );
};

HomeRoutes.propTypes = {
  userRole: t.number,
  match: t.object,
  show: t.number,
};

export default HomeRoutes;
